import {
    BeltContainer,
    createBeltContainer,
} from '@vfde-brix/ws10/belt-container';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    APP_CONTAINER_ID,
    DEVICE_FIRST_HEADLINE_CONTAINER,
    ERROR_NOTIFICATION_CONTAINER_ID,
} from 'Container/App/constants';
import { startAppListening } from 'Container/App/listener';
import { selectHasDevice } from 'Container/App/slice';
import { selectHasError } from 'Container/App/selectors';

/**
 * Mounts a BeltContainer by ID
 */
const mountBeltContainer = (containerId: string): BeltContainer | null => {
    const containerElement = document.getElementById(containerId);

    /* istanbul ignore next */
    if (!containerElement) {
        return null;
    }

    return createBeltContainer(containerElement, NO_PATTERN_BUSINESS_LOGIC);
};

/**
 * Mount app belt container
 */
export const mountAppBeltContainer = (): BeltContainer | null => {
    const beltContainer = mountBeltContainer(APP_CONTAINER_ID);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const hasError = selectHasError(api.getState());

            beltContainer?.toggleContainer(hasError);
        },
    });

    return beltContainer;
};

/**
 * Mount device first belt container
 */
export const mountDeviceFirstBeltContainer = (): BeltContainer | null => {
    const beltContainer = mountBeltContainer(DEVICE_FIRST_HEADLINE_CONTAINER);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasDevice(currentState) !== selectHasDevice(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const hasDevice = selectHasDevice(api.getState());

            beltContainer?.toggleContainer(!hasDevice);
        },
    });

    return beltContainer;
};

/**
 * Mount error belt container
 */
export const mountErrorBeltContainer = (): BeltContainer | null => {
    const beltContainer = mountBeltContainer(ERROR_NOTIFICATION_CONTAINER_ID);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const hasError = selectHasError(api.getState());

            beltContainer?.toggleContainer(!hasError);
        },
    });

    return beltContainer;
};
